module.exports = __webpack_public_path__ + "img/school-24px.28afe358.svg";